import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

export default function CustomizedDialogs() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  
  const handleClose = () => {
    setOpen(false);
  };

  // function submitTest(){
    
  // }
  
  return (
    <>
      <button onClick={handleClickOpen} style={{cursor:'pointer', textAlign:'center', paddingTop: '2px', fontSize:12, fontWeight:'bold', backgroundColor:'#555555', width: 18, height: 18, borderRadius: '50%', border: '1px solid #555555', color: '#FFFFFF'}} >i</button>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent>
          <Grid item md={12} xs={12} className="test-instructions" >
								{/* <div className="btmbdrgry"><h3>Instructions</h3></div> */}
								<p>
                  Formative assessments using randomization is the best method to identify knowledge gaps on a topic quickly. AI helps to fill the identified gaps at the same time, thus accelerating your learning multifold to  help you to master the topic and monitor your performance each day
								</p>
							</Grid>

          </DialogContent>
      </Dialog>
    </>
  );
}
